var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
    'user-widget-button',
    ("user-widget-button--" + _vm.type),
    {
      'user-widget-button--loading': _vm.loading
    }
  ],attrs:{"loading":_vm.loading}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }